// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"ProductsLoadingSkeleton_skeletonContainer__1QX2L","skeletonImage":"ProductsLoadingSkeleton_skeletonImage__3e5YB"};